// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const expandButton = "ExpandButton__expandButton__QAH-x";
export const expanded = "ExpandButton__expanded__jbnXU";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const iconWrapper = "ExpandButton__iconWrapper__XX66H";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "ExpandButton__textCenter__C5z3M";